import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
interface ButtonGroupProps {
  text: string;
}
const ButtonGroup = ({text}: ButtonGroupProps) => {
  return (
    <>
      <button
        type="submit"
        className="text-primary flex items-center min-w-[50px] h-[50px] justify-center text-[25px] bg-farm-shop-500 rounded-full"
      >
        <SpanIcon className="icon-nameSend text-white text-lg" />
      </button>
    </>
  );
};

export default ButtonGroup;
